<script setup>
import BaseLayout from '@/app/layouts/BaseLayout.vue';
import CFVerifyEmailAlert from '@/app/components/layout/CFVerifyEmailAlert.vue';
</script>

<template>
    <BaseLayout>
        <div class="main-container h-fit grow">
            <CFVerifyEmailAlert />

            <slot />
        </div>
    </BaseLayout>
</template>
